import planner from "./planner";
import accessModal from "./accessModal";
import printingShop from "./3dPrintingShop";

export const pods = {
    planner,
    accessModal,
    printingShop
};
